var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLittlePinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6430",
    "data-name": "Groupe 6430",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.615,
    height: 35.008,
    viewBox: "0 0 24.615 35.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5682",
    "data-name": "Trac\\xE9 5682",
    d: "M11.454,34.551a1.025,1.025,0,0,0,1.706,0c2.427-3.641,6-8.137,8.494-12.71,1.992-3.657,2.96-6.775,2.96-9.534A12.308,12.308,0,0,0,0,12.308c0,2.759.968,5.877,2.96,9.534,2.49,4.569,6.071,9.077,8.494,12.71m.853-32.5A10.268,10.268,0,0,1,22.564,12.308c0,2.407-.887,5.2-2.71,8.552a128.943,128.943,0,0,1-7.546,11.3,129.052,129.052,0,0,1-7.546-11.3c-1.824-3.348-2.71-6.145-2.71-8.552A10.268,10.268,0,0,1,12.308,2.051",
    transform: "translate(0 0)",
    fill: "#4188f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5683",
    "data-name": "Trac\\xE9 5683",
    d: "M73.654,79.807A6.154,6.154,0,1,0,67.5,73.654a6.161,6.161,0,0,0,6.154,6.154m0-10.256a4.1,4.1,0,1,1-4.1,4.1,4.107,4.107,0,0,1,4.1-4.1",
    transform: "translate(-61.346 -61.346)",
    fill: "#4188f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittlePinIcon);
export default __webpack_public_path__ + "static/media/little-pin-icon.4ea048bc638dd2de4ac21687d6a928f3.svg";
export { ForwardRef as ReactComponent };